export const DEFAULT_ZOOM = 10;
export const DEFAULT_LOCATION = "Вся Россия";